import type { DialogStack } from "../../components/Dialog/dialogStack";
import { hasInjectionContext, inject } from "vue";
import { DIALOG_STACK_KEY, getDialogStack, tryGetDialogStack } from "../../components/Dialog/dialogStack";

export function useDialogStack(): DialogStack {
  return tryUseDialogStack() ?? getDialogStack();
}

// Also called from event handlers and other non-setup code, which fall through to the installed stack.
export function tryUseDialogStack(): DialogStack | null {
  const injected = hasInjectionContext() ? inject(DIALOG_STACK_KEY, null) : null;
  return injected ?? tryGetDialogStack();
}
